import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime, getLastStr} from "@/helper/method";
import {PoolPO} from "@/model/customer";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {useQueryPoolPage, useReceivePool} from "@/service/pool.s";
import {ViewPool} from "@/pages/Pool/ViewPool";
import {WritePool} from "@/pages/Pool/WritePool";
import {useGlobalActions} from "@/store/global.c";
import {defaultPageParams} from "@/helper/constant";

export const PoolListPage = () => {
    const {
        mutate: poolPageMutate,
        data: poolPageData,
        isPending: poolPagePending,
    } = useQueryPoolPage()

    const {mutateAsync: receivePoolMutate} = useReceivePool()
    const {setToast} = useGlobalActions()

    const columns: GridColDef<PoolPO>[] = [
        {field: "poolName", headerName: "客户名称", flex: 1.5, minWidth: 200},
        {
            field: "contact",
            headerName: "联系人",
            headerAlign: "right",
            align: "right",
        },
        {
            field: "mobile",
            headerName: "联系电话",
            headerAlign: "center",
            align: "center",
            flex: 1
        },
        {
            field: "location",
            headerName: "所在区域",
            headerAlign: "center",
            align: "center",
            renderCell: ({row}) => getLastStr(row.location),
        },
        {
            field: "remark",
            headerName: "备注",
            headerAlign: "center",
            align: "center",
            renderCell: ({row}) => row.remark || "-",
            flex: 1
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    const btnCallback = async ({btn, keys, onSearch}: BtnType<PoolPO>) => {
        if (btn.alias == 'receive') {
            const result = await receivePoolMutate({poolIds: keys})
            if (result.code == 0) {
                setToast({open: true, message: result.msg, severity: "success", variant: 'standard'})
                onSearch && onSearch(defaultPageParams)
            } else {

                setToast({open: true, message: result.msg, severity: "error", variant: 'standard'})
            }
        }
    }

    return (
        <ProTable<PoolPO>
            loading={poolPagePending}
            renderDrawer={{view: <ViewPool/>, write: <WritePool/>}}
            columns={columns}
            btnCallback={btnCallback}
            data={poolPageData?.data}
            onSearch={(params) => {
                poolPageMutate(params);
            }}
            code={"pool"}
        />
    );
};
